// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__309yU","head":"Table_head__1VALu","col":"Table_col__2ryyG"};